// @ts-expect-error -----------------
import { routes } from '@road-to-rome/routes';

import { createRouter, createWebHistory } from 'vue-router';

import { setScrollTop } from 'vant/es/utils';

import { Toast } from '@eaphone/modal';
import { routeMapper } from '@eaphone/utils';
import type { RouteConfig } from '@eaphone/utils';

export const router = createRouter({
  /* globals __webpack_public_path__: readonly */
  history: createWebHistory(__webpack_public_path__),
  scrollBehavior(to) {
    if (to.name === 'analysis') {
      return new Promise((resolve) => {
        setTimeout(() => {
          const ele = document.body.querySelector('.van-config-provider');

          if (ele) {
            setScrollTop(ele, 0);
          }

          resolve({ top: 0 });
        }, 300);
      });
    }
  },
  routes: [
    ...routeMapper(routes as RouteConfig[]),
    {
      path: '/',
      redirect: { name: 'home' },
    },
  ],
});

router.onError((error) => {
  if (error.name === 'ChunkLoadError') {
    Toast.fail('页面加载失败');
  }
});
